import { useLanguage } from '../utils/LanguageContext';
import { ValidatedForm, FormSubmit, FormChoice } from './common/ValidatedForm';
import { DisclosureItem } from '../shared/constants/userConstants';
import { updateUserDisclosuresClientSchema } from '../shared/validations/userValidations';
import translations from './ComponentsTranslations.lang.json';
import { Explainer } from './common/CommonComponents';
import { useAuth } from '../utils/AuthContext.js';

const DisclosureQuestions = ({ onFinish }) => {
  const { lang, optionsForEnum } = useLanguage(translations);
  const { user, api } = useAuth();

  const summaryQuestions = [lang('brokerQuestion'), lang('directorQuestion'), lang('politicalQuestion')];

  const applyOptions = [
    { value: 'none', label: lang('noneApply') },
    { value: 'some', label: lang('someApply') },
  ];

  const handleSubmit = async (formInput) => {
    const someApply = formInput.disclosuresApply === 'some';
    const isDisclosureMarked = (item) => someApply && (formInput.disclosures ?? []).includes(item);
    const disclosures = Object.fromEntries(DisclosureItem.ALL_ITEMS.map((item) => [item, isDisclosureMarked(item)]));
    await api.updateUserDisclosures({ disclosures });
    await onFinish({ disclosures });
  };

  const initialValues =
    user.disclosures && Object.values(user.disclosures).some((disclosuresValue) => disclosuresValue === true)
      ? { disclosuresApply: 'some', disclosures: DisclosureItem.ALL_ITEMS.filter((item) => user.disclosures[item]) }
      : { disclosuresApply: 'none', disclosures: [] };

  return (
    <ValidatedForm
      key="disclosuresQuestions"
      schema={updateUserDisclosuresClientSchema}
      initialValues={initialValues}
      handleSubmit={handleSubmit}
      onFinish={onFinish}
    >
      <FormChoice
        name="disclosuresApply"
        label={
          <div>
            {/* {lang('Do any of the following apply to you?')} */}
            <br />
            <ul>
              {summaryQuestions.map((question, i) => (
                <li key={i}>{question}</li>
              ))}
            </ul>
            <Explainer question={lang('disclosuresExplainerQuestion')} answer={lang('disclosuresExplainerAnswer')} />
          </div>
        }
        options={applyOptions}
        type="radio"
      />
      {({ watch }) =>
        watch('disclosuresApply') === 'some' && (
          <FormChoice
            name="disclosures"
            label={lang('selectDisclosures')}
            options={optionsForEnum(DisclosureItem)}
            type="checkboxgroup"
          />
        )
      }
      <FormSubmit>{lang('next')}</FormSubmit>
    </ValidatedForm>
  );
};

export default DisclosureQuestions;
